
import * as ClassificationActions from '../actions/classification-search.actions';
import { ClassificationSearchState, initialState } from './classification-search.state';
import { createReducer, on, Action } from '@ngrx/store';


export const classificationReducer = createReducer(
  initialState,
  on(ClassificationActions.LoadSearchedClassificationsSuccess, (state, {payload}) => ({
      ...state,
      classifications: payload
  })),
  on(ClassificationActions.DeleteSearchedClassificationsSuccess, (state, {payload}) => ({
    ...state,
    classifications: []
  })),
  on(ClassificationActions.SendSearchedClassificationSuccess, (state, {payload}) => ({
    ...state,
    classification: payload
  })),
  on(ClassificationActions.SendSearchedClassificationPredictionSuccess, (state, {payload}) => ({
    ...state,
    classification: payload
  }))
);

export function reducer(state: ClassificationSearchState | undefined, action: Action) {
  return classificationReducer(state, action);
}
